export const TIMEOUTS = {
  SHORT: 1000,
  MEDIUM: 2000,
  MEDIUM_LONG: 4000,
  LONG: 5000
};


// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/const-timeout.ts